import { IResetPasswordBody } from '../../types';

export const INITIAL_VALUES: IResetPasswordBody = {
  user_id: '',
  code: '',
  password: '',
  password_again: '',
};
